import Alpine from "alpinejs";
import Focus from "@alpinejs/focus";
import Intersect from "@alpinejs/intersect";
import Persist from "@alpinejs/persist";
window.Alpine = Alpine

Alpine.plugin(Focus)
Alpine.plugin(Intersect)
Alpine.plugin(Persist)

// Alpine Stores
Alpine.store('search', false)
Alpine.store('mobileMenu', false)

// Alpine Component Data
Alpine.data('themeConfig', () => ({
    theme: Alpine.$persist('system').as('site_theme'),
    init() {
        this.setTheme()
        this.$watch('theme', this.setTheme.bind(this))
    },
    setTheme() {
        if (this.theme == 'system') {
            document.documentElement.removeAttribute('data-theme')
        } else {
            document.documentElement.setAttribute('data-theme', this.theme)
        }
    },
    light() {
        this.theme = 'light'
    },
    dark() {
        this.theme = 'dark'
    },
    system() {
        this.theme = 'system'
    },
}))

import Fuse from "fuse.js";
Alpine.data('search', (args = {}) => ({
    query: '',
    fuse: null,
    indexPath: '/index.json',
    keys: ['title', 'excerpt', 'category'],
    results: [],
    init() {
        this.$watch('$store.search', (value) => {
            value && this.loadIndex()
        })
        this.$watch('query', this.search.bind(this))
    },
    reset() {
        this.query = ''
        this.$store.search = false
    },
    search() {
        this.results = this.query ? this.fuse.search(this.query) : []
    },
    loadIndex() {
        if (this.fuse) return
        fetch(this.indexPath).then(response => {
            response.json().then(data => {
                this.fuse = new Fuse(data, {
                    // minMatchCharLength: 6,
                    keys: this.keys,
                });
            })
        })
    },
    ...args
}))
Alpine.start()
